import { createContext, PropsWithChildren, useContext } from "react";
import { TableContextType, TableHeadBarType, TableProps } from "../types";

const TableContext = createContext<TableContextType | null>(null);
const TableHeaderContext = createContext<TableHeadBarType | null>(null);


export const useTableContext = () => {
    const context: TableContextType = useContext(TableContext) as TableProps;
    if (context === undefined) console.error("TableContext not defined");
    return context;
}

export const useTableHeaderContext = () => {
    const context: TableHeadBarType = useContext(TableHeaderContext) as TableHeadBarType;
    if (context === undefined) console.error("TableHeaderContext not defined");
    return context;
}

export const TableProvider = ({ children, ...props }: Partial<TableContextType> & PropsWithChildren) => {
    return <TableContext.Provider value={props as any}>
        <TableContext.Consumer>
            {() => children}
        </TableContext.Consumer>
    </TableContext.Provider>
}

export const TableHeaderProvider = ({ children, ...props }: Partial<TableHeadBarType> & PropsWithChildren) => {
    return <TableHeaderContext.Provider value={props as any}>
        <TableHeaderContext.Consumer>
            {() => children}
        </TableHeaderContext.Consumer>
    </TableHeaderContext.Provider>
}

export default TableContext;